import { render, staticRenderFns } from "./MoveStudentsDialog.vue?vue&type=template&id=7954a94e"
import script from "./MoveStudentsDialog.vue?vue&type=script&lang=js"
export * from "./MoveStudentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports